module.exports = __webpack_public_path__ + "static/img/weitu-1.0236b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weitu-1.png
// module id = ZBO3
// module chunks = 0